import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative flex items-center pt-10 md:pt-16 pb-10 md:pb-16 overflow-hidden" data-id="element-149">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] md:w-[800px] h-[500px] md:h-[800px] bg-gold-500/10 rounded-full blur-[100px] md:blur-[120px] pointer-events-none" data-id="element-150" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="flex flex-col items-center text-center gap-4 md:gap-5 max-w-3xl mx-auto" data-id="element-152">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold-500/30 bg-gold-500/10 text-gold-400 text-xs md:text-sm font-medium w-fit" data-id="element-153">
            <ZapIcon size={14} data-id="element-154" />
            <span data-id="element-155">4 Etapas + 3 Bonos Exclusivos</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-7xl font-display leading-[1.05] text-white uppercase" data-id="element-156">
            Todo tu Negocio Digital{' '}
            <span className="text-gradient-gold" data-id="element-157">Listo Para Vender</span>
          </h1>

          {/* Mockup between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="relative w-[70%] max-w-[420px] my-2 md:my-4" data-id="element-158">
            <div className="absolute inset-0 bg-gradient-to-tr from-gold-500/30 to-transparent rounded-2xl blur-2xl" data-id="element-159" />
            <motion.img animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/4wifiaotoBsv2mNDBvSP5x/Mockup_nivel_1.png" alt="Motor de Riqueza Kit Completo" loading="eager" decoding="async" fetchPriority="high" width="420" height="420" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-160" />
          </motion.div>

          <p className="text-base md:text-xl text-gray-300 font-medium max-w-xl leading-relaxed" data-id="element-161">
            Tu negocio digital armado desde cero: tienda, pagos, anuncios y
            productos listos para vender. Sin perder meses.
          </p>

          <div className="flex flex-wrap justify-center gap-2 text-xs md:text-sm text-gray-300 font-medium" data-id="element-162">
            <div className="flex items-center gap-1.5 bg-dark-800 px-2.5 py-1.5 rounded-md border-gold-subtle" data-id="element-163">
              <ZapIcon size={14} className="text-gold-500" data-id="element-164" /> Acceso Inmediato
            </div>
            <div className="flex items-center gap-1.5 bg-dark-800 px-2.5 py-1.5 rounded-md border-gold-subtle" data-id="element-165">
              <StarIcon size={14} className="text-gold-500" data-id="element-166" /> Video + PDF
            </div>
          </div>

          <div className="pt-2 flex flex-col items-center gap-3 w-full" data-id="element-167">
            <Button className="w-full md:w-fit text-base md:text-lg py-4 md:py-5 px-6 md:px-10" data-id="element-168">
              💥 QUIERO MI NEGOCIO LISTO AHORA
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-3 text-xs text-gray-400" data-id="element-169">
              <span className="flex items-center gap-1" data-id="element-170">
                <ShieldCheckIcon size={12} className="text-gold-500" data-id="element-171" /> Garantía
                7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-172">
                <ShieldCheckIcon size={12} className="text-gold-500" data-id="element-173" /> Pago
                seguro
              </span>
              <span className="text-gold-500/80" data-id="element-174">Mercado Pago</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 pt-4 border-t border-white/10 w-full" data-id="element-175">
            <div className="flex gap-0.5" data-id="element-176">
              {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} size={14} className="text-gold-500 fill-gold-500" data-id="element-177" />)}
            </div>
            <div className="text-xs md:text-sm text-gray-400" data-id="element-178">
              <strong className="text-white" data-id="element-179">+500 Alumnos</strong> · 4.9 · Todo
              Argentina
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}